<template>
    <div
            class="modal fade"
            id="sys_addstation_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">添加基站</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">基站名称</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="submitInfo.stst_commname"/>
                            </div>
                            <label class="col-sm-3 control-label">运营商</label>
                            <div class="col-sm-3">
                                <!-- <input name class="form-control" v-model="submitInfo.stst_comm"/> -->
                                <select name class="chosen-select addStation" v-model="submitInfo.stst_comm">
                                    <option value="中国移动">中国移动</option>
                                    <option value="中国联通">中国联通</option>
                                    <option value="中国电信">中国电信</option>
                                    <option value="中国铁塔">中国铁塔</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label">经度</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="submitInfo.stst_longitude"/>
                            </div>
                            <label class="col-sm-3 control-label">纬度</label>
                            <div class="col-sm-3">
                                <input name class="form-control" v-model="submitInfo.stst_latitude"/>
                            </div>
                        </div>
                        <span class="tips">***请在地图上选择基站位置***</span>
                        <div id="addStationMap" name></div>
                    </div>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" class="btn btn-primary" @click="submit">提交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import AMap from 'AMap'

  var map
  var marker
  export default {
    data () {
      return {
        submitInfo: {
          stst_commname: '',
          stst_longitude: '',
          stst_latitude: '',
          stst_comm: '中国移动'
        }
      }
    },
    props: ['msgStationId'],
    mounted: function () {
      var self = this
      map = new AMap.Map('addStationMap', {
        resizeEnable: true,
        center: [116.397477, 39.908692],
        zoom: 13
      })
      marker = new AMap.Marker({
        position: map.getCenter(),
        offset: new AMap.Pixel(-13, -30),
        draggable: true
      })
      marker.setMap(map)

      $('.addStation')
        .chosen({
          disable_search_threshold: 10,
          disable_search: true,
          width: '100%'
        })
        .change(function () {
          self.submitInfo.stst_comm = $('.addStation').val()
        })
    },
    methods: {
      getData: function () {
        var self = this
        self.submitInfo = {
          stst_commname: '',
          stst_longitude: '',
          stst_latitude: '',
          stst_comm: '中国移动'
        }
      },
      submit: function () {
        var self = this
        self.submitInfo.stst_longitude = marker.getPosition().getLng()
        self.submitInfo.stst_latitude = marker.getPosition().getLat()
        if (self.submitInfo.stst_commname.replace(/\s+/g, '') == '') {
          alert('必须输入基站名称')
          return
        }
        console.log(self.submitInfo)
        self.global.axiosPost(
          self,
          'stations/',
          self.submitInfo,
          function (res) {
            console.log(res)
            if (res.message == 'submitted') {
              alert('已提交审核')
              $('#sys_addstation_modal').modal('hide')
            }
          },
          function (res) {
            console.log(res)
            alert('操作失败')
          }
        )
      }
    }
  }
</script>
<style scoped>
    #addStationMap {
        width: 100%;
        height: 300px;
    }

    .tips {
        color: red;
        float: right;
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/stationmanager/addstation.vue